import { SectionProps } from '@wrisk/ui-components'
import React, { FC } from 'react'

import { Proposal } from '../../../domain'
import { usePrincipal } from '../../authentication'
import { AutoRenewalSection } from '../policy/AutoRenewalSection'

export interface ProposalAutoRenewalSectionProps extends SectionProps {
  proposal: Proposal
  subheader?: string
}

export const ProposalAutoRenewalSection: FC<ProposalAutoRenewalSectionProps> = ({
  proposal: { proposalCode, autoRenewalEnabled },
  subheader,
  ...props
}) => {
  const {
    apiClient: { setProposalAutoRenewalEnabled },
  } = usePrincipal()

  return (
    <AutoRenewalSection
      policyOrProposalId={proposalCode}
      isInitiallyEnabled={autoRenewalEnabled}
      subheader={subheader}
      invokeApi={setProposalAutoRenewalEnabled}
      {...props}
    />
  )
}
